<template lang="html">
  <b-navbar type="faded" class="showLargeScreenOnly webHeaderBackground" style="z-index:600">
    <b-navbar-brand href="#">
      <img :src="imgVarsLong" @click="loadAccueil" alt="MoneyRoad" class="heritage largescreen">
      <img :src="imgVarsShort" @click="loadAccueil" alt="MoneyRoad" class="heritage middlescreen">
    </b-navbar-brand>
    <b-navbar-nav class="m-auto" fill>
      <span v-if="!isDisabledItem(item)" v-for="(item, id) in menu" style="height:35px">
        <div v-if="item.list" @mouseover="autoDropdown(true, 'dropdown' + id)" @mouseleave="autoDropdown(false, 'dropdown' + id)">
          <b-nav-item-dropdown :ref="'dropdown' + id" class="h6 col-sm-3 dropDownInner" toggle-class="text-menu font-weight-bold" :text="$t(item.title).toUpperCase()">
            <b-dropdown-group style="top:50px;">
              <b-dropdown-item :disabled="isDisabledItem(subitem)" v-for="subitem in item.list"
                :class="subitem.id === 0 ? 'subItemMenu' : 'subItemText'"
                :key="subitem.id" @click="getClicked(subitem)" v-if="subitem.enabled && canShowSpecific(subitem)">
                {{ $t(subitem.title)}}
                <span v-if="!subitem.link" class="disabled ml-1">{{ $t('common.dsbld') }}</span>
              </b-dropdown-item>
            </b-dropdown-group>
          </b-nav-item-dropdown>
        </div>
        <b-nav-item :disabled="isDisabledItem(item)" v-else
          class="h6 col-sm-3 text-menu font-weight-bold"
          @click="getClicked(item)">
          {{$t(item.title).toUpperCase()}}
          <span v-if="!item.link" class="disabled ml-1">{{ $t('common.dsbld') }}</span>
        </b-nav-item>
      </span>
    </b-navbar-nav>

    <!-- Right Panel (user account information) -->
    <b-navbar-nav class="ml-auto" style="height:55px" fill>
      <div @mouseover="autoDropdown(true, 'log')" @mouseleave="autoDropdown(false, 'log')">
        <b-nav-item-dropdown v-if="this.$engine.user && this.$engine.user.userAccountId !== 1" ref="log" class="logOut" toggle-class="text-menu" right variant="link">
          <template v-slot:button-content>
            <span class="mr-2 h5 text-menu" v-model="userName">{{ userName }}</span>
            <img class="navbarProfileImage" :src="logoProfile"></img>
          </template>
          <b-dropdown-item @click="goToLink('/profile/')" class="subItemText">{{ $t('leftPanelTitle.my_prfl') }}</b-dropdown-item>
          <b-dropdown-item @click="activateModalProfile" class="subItemText">{{ $t('leftPanelTitle.swtch_prfl') }}</b-dropdown-item>
          <b-dropdown-item :disabled="$engine.rights.rightIs('settings_consulter',false)" @click="goToLink('/settings/application/')" class="subItemText">{{ $t('Webheader.settings') }}</b-dropdown-item>
          <b-dropdown-item @click="logout" class="subItemText">{{ this.$t('leftPanelTitle.lgout') }}</b-dropdown-item>
        </b-nav-item-dropdown>
      </div>
    </b-navbar-nav>
  </b-navbar>
</template>

<script>
import ProfileImage from './../../assets/static/images/image-profile.png'
import {loadPage, reloadPage2} from './../../helpers/routing'
import CompanyTheme from './../../helpers/companyTheme.json'
import menuLinkList from './menu.json'
import Services from '@/helpers/services'
import design from '@/design/design.json'

/* Remettre dans menu.json après la démo du 26/02 (quand on pourra prendre le temps
* de mettre des droits sur les fournisseurs) :
{
  "id": 7,
  "title": "Homepage.create_supplier",
  "link": "/suppliers/create/",
  "enabled": true,
  "service": 8
},
{
  "id": 8,
  "title": "Webheader.my_suppliers",
  "link": "/inbox/",
  "enabled": true,
  "service": 8
},
{
  "id": 9,
  "title": "Webheader.verifications",
  "link": "/verifications/SIREN/",
  "enabled": true,
  "service": 8
} **/
/* Barre de navigation sur grands écran (ordinateurs), et liens contenus dans celle-ci */
export default {
  name: 'WebHeader',
  data () {
    return {
      companyId: 0,
      companyTheme: CompanyTheme,
      logoProfile: ProfileImage,
      menu: {},
      userName: '',
      accountType: 0,
      design: design.menu
    }
  },
  created () {
    if (this.$engine.user.get().name != null) {
      this.userName = this.$engine.user.get().name
    }
    this.accountType = this.$engine.user.get().type
    this.companyId = this.$engine.user.get().id
    this.setMenuItems()
    this.$bus.$on('refresh-cache-menu', () => {
      this.userName = this.$engine.user.get().name
      this.accountType = this.$engine.user.get().type
      this.setMenuItems()
    })
  },
  computed: {
    imgVarsLong () {
      return this.design.headbandLogoLong
    },
    imgVarsShort () {
      return this.design.headbandLogoShort
    }
  },
  methods: {
    canShowSpecific (subItem) {
      if ((subItem.link === '/rights/profiles/' || subItem.link === '/accountMembers/') && this.$engine.user.get().type === '2') {
        return false
      }
      return true
    },
    setMenuItems () {
      this.menu = menuLinkList['linkContent']
    },
    logout () {
      this.$bus.emit('logout')
    },
    activateModalProfile () {
      this.$f7.popup('#switch-profile-true')
    },
    goToLink (linkToGo) {
      this.$f7.mainView.router.load({url: linkToGo, reload: true})
    },
    getClicked (subitem) {
      switch (subitem.link) {
        case '/directPayments/creation/':
          this.$bus.$emit('service:change', 'Direct Payments')
          this.$bus.$emit('direct-inbox-filtered', 1)
          this.$engine.user.changeService(this.$engine.services.getServiceById(Services.DIRECTPAYMENTS))
          this.$engine.user.currentService.id = Services.DIRECTPAYMENTS
          break
        case '/payments/newPayments/':
          this.$bus.$emit('service:change', 'Payments')
          this.$bus.$emit('direct-debit-filtered', 1)
          this.$engine.user.changeService(this.$engine.services.getServiceById(Services.PAYMENTS))
          this.$engine.user.currentService.id = Services.PAYMENTS
          break
        case '/directDebit/creation/':
          this.$bus.$emit('service:change', 'Direct Debit')
          this.$bus.$emit('inbox-filtered', 1)
          this.$engine.user.changeService(this.$engine.services.getServiceById(Services.DIRECTDEBIT))
          this.$engine.user.currentService.id = Services.DIRECTDEBIT
          break
        case '/businessDocument/sendForm/':
        case '/businessDocument/requestForm/':
          this.$bus.$emit('service:change', 'Business Documents')
          this.$bus.$emit('inbox-filtered', 1)
          this.$engine.user.changeService(this.$engine.services.getServiceById(Services.DOCUMENTSERVICE))
          this.$engine.user.currentService.id = Services.DOCUMENTSERVICE
          break
        case '/suppliers/create/':
          this.$bus.$emit('service:change', 'Suppliers')
          this.$bus.$emit('inbox-filtered', 1)
          this.$engine.user.changeService(this.$engine.services.getServiceById(Services.SUPPLIERS))
          this.$engine.user.currentService.id = Services.SUPPLIERS
          break
        case String(subitem.link.match('^/inbox/.*')):
          switch (subitem.service) {
            case 1:
              this.$bus.$emit('service:change', 'Payments')
              this.$bus.$emit('direct-debit-filtered', 1)
              this.$engine.user.changeService(this.$engine.services.getServiceById(Services.PAYMENTS))
              this.$engine.user.currentService.id = Services.PAYMENTS
              break
            case 2:
              this.$bus.$emit('service:change', 'Direct Debit')
              this.$bus.$emit('inbox-filtered', 1)
              this.$engine.user.changeService(this.$engine.services.getServiceById(Services.DIRECTDEBIT))
              this.$engine.user.currentService.id = Services.DIRECTDEBIT
              break
            case 6:
              this.$bus.$emit('service:change', 'Direct Payments')
              this.$bus.$emit('direct-inbox-filtered', 1)
              this.$engine.user.changeService(this.$engine.services.getServiceById(Services.DIRECTPAYMENTS))
              this.$engine.user.currentService.id = Services.DIRECTPAYMENTS
              break
            case 7:
              this.$bus.$emit('service:change', 'Business Documents')
              this.$bus.$emit('inbox-filtered', 1)
              this.$engine.user.changeService(this.$engine.services.getServiceById(Services.DOCUMENTSERVICE))
              this.$engine.user.currentService.id = Services.DOCUMENTSERVICE
              break
            case 8:
              this.$bus.$emit('service:change', 'Suppliers')
              this.$bus.$emit('inbox-filtered', 1)
              this.$engine.user.changeService(this.$engine.services.getServiceById(Services.SUPPLIERS))
              this.$engine.user.currentService.id = Services.SUPPLIERS
              break
            case 9:
              this.$bus.$emit('service:change', 'Verifications')
              this.$bus.$emit('inbox-filtered', 1)
              this.$engine.user.changeService(this.$engine.services.getServiceById(Services.VERIFICATIONS))
              this.$engine.user.currentService.id = Services.VERIFICATIONS
              break
            default:
            /*  "Tous les services", à reprendre plus tard
            {id: 4, title: 'Webheader.all_usages', link: '/inbox/'} */
              break
          }
          break
        default:
          break
      }
      let that = this
      reloadPage2(that, subitem.link)
    },
    getBackground () {
      if (this.companyTheme[this.companyId] && this.companyTheme[this.companyId].background) {
        return 'background: ' + this.companyTheme[this.companyId].background
      }
    },
    getLargeLogo () {
      if (this.companyTheme[this.companyId] && this.companyTheme[this.companyId].logoLarge) {
        return './../../assets/static/images/logo/' + this.companyTheme[this.companyId].logoLarge
      } else {
        return require('./../../assets/static/images/logo/moneyroad_white_green.png')
      }
    },
    getMiddleLogo () {
      if (this.companyTheme[this.companyId] && this.companyTheme[this.companyId].logoMiddle) {
        return './../../assets/static/images/logo/' + this.companyTheme[this.companyId].logoMiddle
      } else {
        return require('./../../assets/static/images/logo/mrlogo.png')
      }
    },
    loadAccueil () {
      var that = this
      loadPage(that, {url: '/home/'})
    },
    goToLoginPage () {
      var that = this
      loadPage(that, {url: '/login/'})
    },
    autoDropdown (value, id) {
      Object.keys(this.$refs).forEach((item) => {
        if (item === id) {
          if (this.$refs[item][0]) {
            this.$refs[item][0].visible = value
          } else {
            this.$refs[item].visible = value
          }
        }
      })
    },
    isDisabledItem (item) {
      if (item && item.right_disable && item.right_disable.right) { // If item has a right value
        if (item.right_disable.right === 'rights_profile_consult') {
          return this.$engine.user.get().id === this.$engine.user.get()
          ? this.$engine.rights.rightIs('rights_admin_consulter', item.right_disable.state)
          : this.$engine.rights.rightIs(item.right_disable.right, item.right_disable.state)
        }
        // Return true if the right has the same state as the disabling state
        return this.$engine.rights.rightIs(item.right_disable.right, item.right_disable.state)
      }
      return false
    }
  }

}
</script>

<style>
.webHeaderBackground {
  background-color: var(--headbandColor);
}
.navbar:after {
  background-color: var(--headbandColor);
}
.dropDownInner .dropdown-menu {
  background-color: var(--headbandColor) !important;
  top: -8px;
}
.subItemText a {
  color: var(--headbandTextColor);
}
.subItemText a:hover {
  background-color: var(--headbandColorHover);
  color: var(--headbandTextColorHover);
}
.subItemMenu a {
  background-color: var(--headbandColor);
  font-weight: bolder;
  color: var(--headbandTextColor);
}
.subItemMenu a:hover {
  background-color: var(--headbandColor);
  font-weight: bolder;
  color: var(--headbandTextColor);
}
.logOut .dropdown-menu {
  background-color: var(--headbandColor) !important;
  top: 40px;
  width: 100%;
}

@media(min-width: 1731px) {
  .middlescreen {
    display: none;
  }
  .heritage {
    width: 360px;
  }
}
@media(max-width: 1730px) {
  .largescreen {
    display: none;
  }
  .heritage {
    width: 60px;
  }
}
</style>



// WEBPACK FOOTER //
// WebHeader.vue?3b454860